export default __webpack_public_path__ + "static/media/ic-chat.cde1b275.svg";